import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { BuildingIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { InputLabel } from "@material-ui/core";

export const ModificationElectricBusinessDemand: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } = useFormModel<
        ChangeNames.MODIFICATION_ELECTRIC_BUSINESS_DEMAND
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<BuildingIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Gewerbeleistung
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Geben Sie die bestehende Gewerbeleistung an. Die benötigte Leistung
                            erhalten Sie ggf. von Ihrem Elektroinstallateur.
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.modificationElectricBusinessDemand.value.installed}
                        {...getFieldProps("modificationElectricBusinessDemand.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.modificationElectricBusinessDemand.value.installed = checked;
                                values.modificationElectricBusinessDemand.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.modificationElectricBusinessDemand.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={
                                values.modificationElectricBusinessDemand.value.demand.precision
                            }
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.modificationElectricBusinessDemand.value.demand.unit}
                            value={
                                values.modificationElectricBusinessDemand.value.demand.amount || ""
                            }
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.modificationElectricBusinessDemand.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.modificationElectricBusinessDemand.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
